export const format = (format = "yyyy-MM-DD", date = Date.now()) => {
    const _date = new Date(date);
    return format.replace(/(yyyy|mm|dd|MM|DD|H|h|loc|i|s|a)/g, t => {
        switch (t) {
            case "yyyy":
                return _date.getFullYear();
            case "mm":
                return _date.getMonth() + 1;
            case "dd":
                return _date.getDate();
            case "MM":
                return zero(_date.getMonth() + 1);
            case "DD":
                return zero(_date.getDate());
            case "H":
                return zero(_date.getHours());
            case "h":
                return minHour(_date.getHours());
            case "i":
                return zero(_date.getMinutes());
            case "s":
                return zero(_date.getSeconds());
            case "a":
                return krTime(_date.getHours()); // 오전 오후
            case "loc":
                return "T" + zero(_date.getHours()); // local : using for input type='datetime-local'
            default:
                return false;
        }
    });
};

export const CurrentDifferType = {
    order: "",
    datetime: false,
    withToday: false
};

export const dateDiffCurrent = (differ, options = CurrentDifferType) => {
    const {order, withToday} = options;
    const _differ = pure(differ).getTime();
    const _current = pure(format("yyyy/MM/DD")).getTime();

    if (order === "prev") {
        if (withToday) {
            return _differ < _current ? true : false;
        }
        return _differ < _current ? true : false;
    } else if (order === "next") {
        if (withToday) {
            return _differ <= _current ? false : true;
        }

        return _differ < _current ? false : true;
    }
};

// use for dateFormat
export const now = () => Date.now();
export const pure = value => new Date(value);
export const krTime = value => (value >= 0 && 12 >= value ? "오전" : "오후");
export const zero = value =>
    value.toString().length === 1 ? `0${value}` : value;
export const minHour = value => (value > 12 ? zero(value - 12) : zero(value));
